import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, openContent } from '@nu-art/thunderstorm-frontend/index';
import './Component_FocusedProtocolInfo.scss';
import { pathwayType_SingleState } from '@app/pathway-shared';
import { PopUp_ProtocolGoTo } from '../../../pop-ups/PopUp_ProtocolGoTo/PopUp_ProtocolGoTo.js';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ModuleFE_ProvideInfo } from '../../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { Component_ProtocolGraph } from '../working-diagnosis/Component_ProtocolGraph/Component_ProtocolGraph.js';
export class Component_FocusedProtocolInfo_Mini extends ComponentSync {
    //######################### Life Cycle ##########################
    deriveStateFromProps(nextProps, state) {
        state.protocolData = nextProps.protocolData;
        state.showDetails ??= false;
        return state;
    }
    //######################### Logic ##########################
    openGoTo = (e) => {
        PopUp_ProtocolGoTo.show(e, { protocolData: this.state.protocolData });
    };
    //######################### Render ##########################
    render() {
        return _jsxs("div", { className: 'focused-protocol-info mini', children: [this.render_Graph(), this.render_GoToButton()] });
    }
    render_Graph = () => {
        const pathwayType = this.state.protocolData.pathway.type;
        if (pathwayType === pathwayType_SingleState)
            return _jsx("div", { className: 'focused-protocol-info__no-protocol', children: "This DDX has no designated protocol" });
        const context = ModuleFE_ProvideInfo.getCurrentProtocolContextData();
        if (!context)
            return;
        return _jsx(Component_ProtocolGraph, { context: context });
    };
    render_GoToButton = () => {
        const pathwayType = this.state.protocolData.pathway.type;
        if (ModuleFE_EMInterface.isAvatarMode() || ModuleFE_EMInterface.isPostDisposition() || pathwayType === pathwayType_SingleState)
            return;
        return _jsx(Button, { className: 'go-to-button', variant: 'header-button', onClick: this.openGoTo, ...openContent.tooltip.top('tooltip__go-to', _jsx(_Fragment, { children: "Use this button or double-click on the state to jump to a specific state" }), { offset: 8 }), children: "Go To" });
    };
}
//# sourceMappingURL=Component_FocusedProtocolInfo_Mini.js.map